import { render, staticRenderFns } from "./tab-approved.vue?vue&type=template&id=0f856c2a&scoped=true"
import script from "./tab-approved.vue?vue&type=script&lang=js"
export * from "./tab-approved.vue?vue&type=script&lang=js"
import style0 from "./tab-approved.vue?vue&type=style&index=0&id=0f856c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f856c2a",
  null
  
)

export default component.exports